export const ICON_SIZES = [8, 12, 16, 18, 20, 24, 32, 48, 64];

export const ICON_BASE_COLORS = [
  'white',
  'black',
  'links',
  'primary',
  'primary-light',
  'secondary',
  'secondary-light',
  'warning',
  'warning-light',
  'warning-dark',
  'danger',
  'danger-light',
  'calm',
  'calm-light',
  'gray-100',
  'gray-200',
  'gray-300',
  'gray-500',
  'gray-600',
  'gray-900',
];

export const ICON_ASSIGNMENT_COLORS = [
  'coral',
  'ruby',
  'chili',
  'raffia',
  'sienna',
  'carrot',
  'egg',
  'olive',
  'bamboo',
  'meadow',
  'aquamarine',
  'aqua',
  'sky',
  'sea',
  'ocean',
  'navy',
  'cornflower',
  'wisteria',
  'mauvelous',
  'mulberry',
];

export default {
  ICON_SIZES,
  ICON_BASE_COLORS,
  ICON_ASSIGNMENT_COLORS,
};
